import "@majitap/ui/styles.css";
import { ArcProvider, configureMaps } from "@majitap/ui";
import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createConsoleRouter } from "./router";
import { RouterLink } from "./router-link";
import { meQuery } from "./session";

/**
 * A call answered COMPANY_NOT_SELECTED: the session lost its company (or never had one). Back to
 * Choose a company, wherever it happened.
 */
function onError(error: unknown) {
  if ((error as { code?: string } | null)?.code !== "COMPANY_NOT_SELECTED") return;
  void queryClient.invalidateQueries({ queryKey: meQuery.queryKey });
  void router.navigate({ to: "/choose-company", search: { next: window.location.pathname } });
}

const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError }),
  mutationCache: new MutationCache({ onError }),
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: true } },
});
const router = createConsoleRouter(queryClient);
// Mapbox's public token (pk.…, restricted to the console's URLs), set when building (ADR 0010)
configureMaps({ accessToken: import.meta.env.VITE_MAPBOX_TOKEN });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider
        router={router}
        InnerWrap={({ children }) => <ArcProvider link={RouterLink}>{children}</ArcProvider>}
      />
    </QueryClientProvider>
  </StrictMode>,
);
